module.exports = __webpack_public_path__ + "static/img/red_car.4cb21a8c.png";